const styles = {
  container: { height: '100%', display: 'flex', flexDirection: 'column' },
  chartWrapper: { position: 'relative', flexGrow: 1, minHeight: 140 },
  loadingOverlay: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
  loadingText: { fontSize: '0.88rem', color: 'text.secondary', fontWeight: 500 },
};

export const rechartsStyles = {
  margin: { top: 4, right: 12, left: 6, bottom: 24 },
  tooltip: { fontSize: 10, padding: '4px 8px' },
  legend: { fontSize: 10, paddingTop: 0 },
};

export const CHART_COLORS = ['#eaa861', '#5236AB', '#EA6361', '#4A90E2'];

export default styles;
